import { DetailsList, DetailsListItem } from "@synota-io/synota-shared-ui";
import { IUserReceiveConfigurationResponse } from "../../../../api/hooks/useUserReceiveConfiguration";
import { Check, Close } from "@mui/icons-material";

export const UserStrikeReceiveConfiguration = ({
  configuration,
}: {
  configuration: IUserReceiveConfigurationResponse;
}) => {
  if (!configuration || !("StrikeConfiguration" in configuration)) {
    return null;
  }

  return (
    <DetailsList>
      <DetailsListItem title="Strike Handle">
        {configuration.StrikeConfiguration.strike_handle}
      </DetailsListItem>
      <DetailsListItem title="Receive Bitcoin">
        {configuration.StrikeConfiguration.receive_btc ? <Check /> : <Close />}
      </DetailsListItem>
    </DetailsList>
  );
};
